import { Text } from '@/components/ui'
import { twMerge } from 'tailwind-merge'

interface ResourceMessageProps {
  isMobileView?: boolean
}
function ResourceMessage({ isMobileView = false }: ResourceMessageProps) {
  return (
    <div
      className={twMerge(
        ' rounded-lg bg-[#f1f1fb] border-[1px] border-[#bfcae8] ',
        isMobileView ? 'w-full' : 'w-[52%]',
      )}
    >
      <div className="flex flex-col justify-center items-start p-6">
        <Text variant="heading" className="text-primary">
          Your requested resource is on the way.
        </Text>
        <Text variant="heading" className="text-primary">
          Please complete your registration and check your inbox.
        </Text>
        <Text className="pt-1 text-sm text-primary">
          Please check your spam folder and whitelist us for future emails.
        </Text>
      </div>
    </div>
  )
}

export default ResourceMessage
